import React from 'react';
import styled from 'styled-components';
import DeltaBadge from './DeltaBadge';
import MatchIndicator from './MatchIndicator';

const TH = styled.th`
  text-align: left;
  padding: ${p => p.theme.spacing[2]}px ${p => p.theme.spacing[3]}px;
  font-size: ${p => p.theme.typography.sizes.sm};
  color: ${p => p.theme.colors.text.secondary};
  font-weight: ${p => p.theme.typography.weights.semibold};
  border-bottom: 1px solid ${p => p.theme.colors.border};
  vertical-align: top;
`;

const TD = styled.td`
  padding: ${p => p.theme.spacing[2]}px ${p => p.theme.spacing[3]}px;
  font-size: ${p => p.theme.typography.sizes.sm};
  color: ${p => p.theme.colors.text.primary};
  border-bottom: 1px solid ${p => p.theme.colors.border};
  vertical-align: top;
`;

const IndicatorWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const MobileDt = styled.dt`
  font-size: ${p => p.theme.typography.sizes.sm};
  color: ${p => p.theme.colors.text.secondary};
  font-weight: ${p => p.theme.typography.weights.semibold};
  margin-top: ${p => p.theme.spacing[3]}px;
  margin-bottom: ${p => p.theme.spacing[1]}px;
`;

const MobileDd = styled.dd`
  margin: 0 0 ${p => p.theme.spacing[2]}px 0;
  padding: ${p => p.theme.spacing[2]}px ${p => p.theme.spacing[3]}px;
  border: 1px solid ${p => p.theme.colors.border};
  border-radius: ${p => p.theme.radius.md}px;
  background: ${p => p.theme.colors.surface};
  font-size: ${p => p.theme.typography.sizes.sm};

  > div {
    padding: 2px 0;
  }
`;

const ComparisonRow = ({ label, drikValue, vakyamValue, delta, nameMatch, lang = 'en', variant = 'desktop' }) => {
  const showDelta = delta && typeof delta.minutes === 'number';
  const showMatch = nameMatch !== null && nameMatch !== undefined;

  if (variant === 'mobile') {
    return (
      <>
        <MobileDt>{label}</MobileDt>
        <MobileDd>
          <div><strong>Drik:</strong> {drikValue || '\u2014'}</div>
          <div><strong>Vakyam:</strong> {vakyamValue || '\u2014'}</div>
          {(showDelta || showMatch) && (
            <div>
              <IndicatorWrap>
                {showDelta && <DeltaBadge delta={delta} />}
                {showMatch && <MatchIndicator match={nameMatch} lang={lang} />}
              </IndicatorWrap>
            </div>
          )}
        </MobileDd>
      </>
    );
  }

  return (
    <tr>
      <TH scope="row">{label}</TH>
      <TD>{drikValue || '\u2014'}</TD>
      <TD>{vakyamValue || '\u2014'}</TD>
      <TD>
        <IndicatorWrap>
          {showDelta && <DeltaBadge delta={delta} />}
          {showMatch && <MatchIndicator match={nameMatch} lang={lang} />}
        </IndicatorWrap>
      </TD>
    </tr>
  );
};

export default ComparisonRow;
